import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';


const lineVariant = {
  hidden: { scaleX: 0 },
  visible: { scaleX: 1, transition: { duration: 0.8, ease: "circOut" } },
  exit: { scaleX: 0, transition: { duration: 0.4, ease: "easeInOut" } }
};

const titleVariant = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { delay: 0.2, duration: 0.5 } },
  exit: { opacity: 0, transition: { delay: 0.4, duration: 0.3 } }
};

const cardFlipVariant = {
  hidden: { rotateY: -90, opacity: 0 },
  visible: { rotateY: 0, opacity: 1, transition: { duration: 1.2, ease: "backOut" } },
  exit: { rotateY: 90, opacity: 0, transition: { duration: 0.4, ease: "easeIn" } }
};

const cardFadeVariant = {
  hidden: { y: 50, opacity: 0 },
  visible: { y: 0, opacity: 1, transition: { duration: 0.6, ease: "easeOut" } },
  exit: { y: 20, opacity: 0, transition: { duration: 0.3 } }
};

export default function Services() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 900);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const currentCardVariant = isMobile ? cardFadeVariant : cardFlipVariant;
  const cocktailHD = process.env.REACT_APP_COCKTAIL_HD || "PRICE NOT FOUND"; 
  const bridalHD = process.env.REACT_APP_BRIDAL_HD || "PRICE NOT FOUND";

  return (
    <div id='services' className='section Services BridalCocktail'>
      <div className='MainServiceContainer'>
        
        <div className='ServiceTitleContainer'>
          <motion.div className='ServiceLine' initial="hidden" whileInView="visible" viewport={{ once: true }} exit="exit" variants={lineVariant} style={{ originX: 1 }}></motion.div>
          
          <motion.span className='ServiceTitle' initial="hidden" whileInView="visible" viewport={{ once: true }} exit="exit" variants={titleVariant}>
            Bridal & Cocktail
          </motion.span>
          
          <motion.div className='ServiceLine' initial="hidden" whileInView="visible" viewport={{ once: true }} exit="exit" variants={lineVariant} style={{ originX: 0 }}></motion.div>
        </div>

        <div className='ServicesCardWrapper' style={{ perspective: '1200px' }}>
          <motion.div className='ServiceCard' initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={currentCardVariant} exit="exit" style={{ transformStyle: "preserve-3d" }}>
            <span className='CardTitle'>Bridal</span>
            <span className='CardPrice'><span className='ServiceRuppe'>₹</span>{bridalHD}</span>
            <span className='CardInText'>In Delhi/NCR</span>
            <Link style={{ textDecoration: 'none', display:'block' }} to='/bridal'><button className='CardButton'>View Details</button></Link>
          </motion.div>

          <motion.div className='ServiceCard' initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} variants={currentCardVariant} transition={{ ...currentCardVariant.visible.transition, delay: 0.2 }} exit="exit" style={{ transformStyle: "preserve-3d" }}>
            <span className='CardTitle'>Cocktail</span>
            <span className='CardPrice'><span className='ServiceRuppe'>₹</span>{cocktailHD}</span>
            <span className='CardInText'>In Delhi/NCR</span>
            <Link style={{ textDecoration: 'none', display:'block' }} to='/cocktail'><button className='CardButton'>View Details</button></Link>
          </motion.div>
        </div>

      </div>
    </div>
  )
}